module.exports = __webpack_public_path__ + "static/Diners Club-7bcf34e42fc0bbf7be1b3d1b45c7303c.svg";